export const data = [
    { label: 'One', value: '1' },
    { label: 'Two', value: '2' },
    { label: 'Three', value: '3' },
    { label: 'Four', value: '4' },
    { label: 'Five', value: '5' },
];
export const args = {
    label: 'Select Drop Down',
    data: data,
};
export const argTypes = {};
